import React from "react";

const Loading = () => {
  return (
    <p><span className="spinner-border text-secondary" role="status" /> Loading</p>
  );
};

export default Loading;
